import React from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { UserX, ArrowLeft } from 'lucide-react';

const ImpersonationBanner = () => {
  const { isImpersonating, user, exitImpersonation } = useAuth();

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="bg-purple-600 text-white px-4 py-2" data-testid="impersonation-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <UserX className="w-5 h-5" />
          <p className="text-sm font-medium">
            You are viewing as: <strong>{user?.name || user?.email}</strong>
            <span className="hidden sm:inline text-purple-200 ml-2">({user?.email})</span>
          </p>
        </div>
        
        <Button
          size="sm"
          variant="secondary"
          onClick={exitImpersonation}
          className="bg-white text-purple-600 hover:bg-purple-50"
          data-testid="exit-impersonation-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Exit & Return to Admin
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
